import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { EQM3010_R01Dto } from './Dto_EQM3010_R01';
import { EQM3010_R01Filter } from './Store_EQM3010_R01';

const baseUrl = `${config.apiUrl}/EQM3010_R01`;

export const getEQM3010_R01List = async (option: string, params: Partial<EQM3010_R01Filter>) =>
	getData<ResponseDto<EQM3010_R01Dto[]>>(`${baseUrl}/${option}`, { params: params as EQM3010_R01Filter });

export const getEQM3010_R01AllCount = async (params: Partial<EQM3010_R01Filter>) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params: params as EQM3010_R01Filter });

export const downloadExcel_EQM3010_R01 = async (params: Partial<EQM3010_R01Filter>) =>
	getData<ResponseDto<string>>(`${baseUrl}/excel`, { params: params as EQM3010_R01Filter });

export const postEQM3010_R01 = async (list: EQM3010_R01Dto[]) =>
	postData<EQM3010_R01Dto[], ResponseDto<EQM3010_R01Dto[]>>(baseUrl, list);

export const patchEQM3010_R01 = async (list: EQM3010_R01Dto[]) =>
	patchData<EQM3010_R01Dto[], ResponseDto<EQM3010_R01Dto[]>>(baseUrl, list);

export const deleteEQM3010_R01 = async (dto: EQM3010_R01Dto) =>
	deleteData<ResponseDto<void>>(baseUrl, { data: dto });

export const copyPreviousYearEQM3010_R01 = async (dto: Partial<EQM3010_R01Dto>) =>
	postData<Partial<EQM3010_R01Dto>, ResponseDto<void>>(`${baseUrl}/copy-previous-year`, dto);
